<template>
  <v-btn
    :class="[buttonClass, 'hidden-sm-and-down', 'fab-back-button']"
    fab
    fixed
    @click="handleClick"
  >
    <v-icon>
      {{ getThemedVar('backButtonIcon', 'arrow_back') }}
    </v-icon>
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    moveBack: {
      type: Boolean,
      default: true,
    },
    buttonClass: {
      type: String,
      required: false,
    }
  },
  computed: {
    ...mapGetters('service', ['getThemedVar']),
  },
  methods: {
    handleClick() {
      if (this.moveBack) {
        this.$router.go(-1);
      } else {
        this.$emit('click');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fab-back-button {
  z-index: 20;
  top: var(--app-main-top);
  left: 15px;
  border-radius: 28px;
  width: 56px;
  height: 56px;

  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: var(--back-button-color, #ffffff) !important;
  caret-color: var(--back-button-color, #ffffff) !important;
  box-shadow: var(--back-button-color-box-shadow, 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)) !important;
}
</style>
